export const DATA_GRID_SX = {
    border: "none",
    fontSize: "14px",
    "& .MuiDataGrid-columnHeaderTitle": {
        fontSize: "14px",
        fontWeight: 600,
    },
    "& .MuiDataGrid-cell": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
};
export const LOADING_OVERLAY_SX = {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    zIndex: 1,
    borderRadius: 2,
};
export const DETAIL_SUMMARY_SX = {
    backgroundColor: "#F8F9FA",
    borderRadius: 1.5,
    py: 1,
    px: 1.5,
    position: "sticky",
    top: 0,
    zIndex: 1,
};
export function formatEuro(value) {
    if (value == null)
        return "—";
    return `€ ${value.toLocaleString("nl-NL", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
